import {
	all,
	always,
	applySpec,
	find,
	ifElse,
	isEmpty,
	isNil,
	map,
	pipe,
	pluck,
	prop,
	propEq,
	propOr,
	sum,
} from 'ramda';

export const jobIsCompletedFilled = factors => all(
	factor => !isNil(factor.selectedDegree) && !isEmpty(factor.selectedDegree),
	factors,
);

export const getFactorRateSum = factors => pipe(
	pluck('selectedDegree'),
	map(propOr(0, 'rate')),
	sum,
	value => value.toFixed(2),
)(factors);

const parseDegree = applySpec({
	uuid: prop('code'),
	name: prop('name'),
	rate: prop('rate'),
});

const parseResponseDegrees = map(parseDegree);

const parseResponseFactors = factors => map(
	applySpec({
		id: prop('id'),
		name: prop('name'),
		urlImage: prop('urlImage'),
		degrees: pipe(prop('grades'), parseResponseDegrees),
		selectedDegree: factor => pipe(
			prop('gradeCode'),
			ifElse(
				gradeCode => !isEmpty(gradeCode) && !isNil(gradeCode),
				gradeCode => parseDegree(find(propEq('code', gradeCode), propOr([], 'grades', factor))),
				always(undefined),
			),
		)(factor),
	}),
	factors,
);

export const parseResponseJobs = jobs => map(
	applySpec({
		id: prop('id'),
		name: prop('name'),
		rate: propOr(0, 'summaryGrades'),
		factors: pipe(prop('factors'), parseResponseFactors),
		completed: pipe(prop('factors'), parseResponseFactors, jobIsCompletedFilled),
	}),
)(jobs);

const parsePayloadFactors = map(
	applySpec({
		id: prop('id'),
		name: prop('name'),
		gradeCode: pipe(prop('selectedDegree'), prop('uuid')),
	}),
);

export const parsePayloadJobs = map(
	applySpec({
		id: prop('id'),
		name: prop('name'),
		summaryGrades: prop('rate'),
		factors: pipe(prop('factors'), parsePayloadFactors),
	}),
);

export default {};




// WEBPACK FOOTER //
// ./src/modules/polls/utils/custom/job-evaluation.js